export const norm = (s) =>
  (s ?? "")
    .toString()
    .trim()
    .replace(/\s+/g, "")
    .replace(/[\/]/g, "")
    .toUpperCase();

export const TOOLTIP_BY_NAME = {
  V: "Filter op geldigheid VOG",
  I: "Filter op geldigheid Identiteitsbewijs",
  P: "Filter op aanwezigheid Pabo-diploma",
  "36": "Filter op basis van 36 maanden bewaking",
  KR: "Filter op basis van ketenregeling",
  BK: "Filter op basis van blokkeerdata",
  GYM: "Filter op gymbevoegdheid",
  MC: "Filter op matchcode",
  FV: "Filter functies volgens vervanger",
  FB: "Filter functies volgens bestuur",
  "FB_+": "Filter functies volgens bestuur: Ja",
  "FB_-": "Filter functies volgens bestuur: Nee",
  "FB_+!": "Filter functies volgens bestuur: Ja of Onbekend",
  "FB_!": "Filter functies volgens bestuur: Onbekend",
  "FB_N": "Filter functies volgens bestuur: Uitgeschakeld",
  "FV_+": "Filter functies volgens vervanger: Ja",
  "FV_-": "Filter functies volgens vervanger: Nee",
  "FV_+!": "Filter functies volgens vervanger: Ja of Onbekend",
  "FV_!": "Filter functies volgens vervanger: Onbekend",
  "FV_N": "Filter functies volgens vervanger: Uitgeschakeld",
  CON: "Continuïteit A/B — A: aantal inzetten op deze school (12 mnd), B: aantal keren dat de afwezige is vervangen (lopend schooljaar).",
  KM: "Reisafstand school naar vervanger",
  LFT: "Leeftijd",
  SV: "S = Evaluatiescore door school, V = Evaluatiescore door vervanger",
  MESSAGES: "Verstuur bulk-sms",
  CONTACTHISTORIE: "Contacthistorie",
  SELECTED_FILTER: "Filter geselecteerde vervangers",
  SELECTED: "Geselecteerde vervangers",
  "%B": "Percentage beschikbare dagdelen in aanvraag",
  "%E": "Percentage efficiëntie",
  BS: "Beschikbaarheid",
  BS_MODE_DAGDELEN: "Beschikbaarheidsmodus dagdelen",
  BS_MODE_ROOSTER: "Beschikbaarheidsmodus rooster",
  CONTRACT_SHOW: "Contracttype tonen",
  CONTRACT_HIDE: "Contracttype niet tonen",
  FILTER_VERVANGERS: "Filter vervangers",
  SORT: "Vervangers sorteren",
  LEGEND: "Legenda",
  COMMENTS: "Bestuursmemo",
  "+": "Beschikbaar",
  "-": "Niet beschikbaar",
  "!": "Beschikbaarheid onbekend",
  LOCKED: "Filter & controle: Uitgeschakeld voor dit criterium",
  INFO: "Info",
};

export const COMMENTS = {
  Bestuursmemo: "Bestuursmemo",
  Schoolinformatie: "Schoolinformatie",
};

export const getHeaderTooltip = (name, value) => {
  if (norm(name) === "FB" && value) {
    return TOOLTIP_BY_NAME[`FB_${norm(value)}`] ?? null;
  }
  if (norm(name) === "FV" && value) {
    return TOOLTIP_BY_NAME[`FV_${norm(value)}`] ?? null;
  }
  return (
    TOOLTIP_BY_NAME[norm(name)] ??
    TOOLTIP_BY_NAME[norm(value)] ??
    TOOLTIP_BY_NAME[name] ??
    TOOLTIP_BY_NAME[value] ??
    null
  );
};

export const getIconTooltip = (key) => TOOLTIP_BY_NAME[key] ?? null;
export const getTip = getIconTooltip;